import React from 'react';

import StoreErrorFlagContext from './StoreErrorFlagContext';
import { type ShowStoreErrorFlag } from './StoreErrorFlagId';

export const StoreErrorFlagProvider = ({
	showFlag,
	children,
}: {
	showFlag: ShowStoreErrorFlag;
	children: React.ReactNode;
}): React.JSX.Element => (
	<StoreErrorFlagContext.Provider value={showFlag}>{children}</StoreErrorFlagContext.Provider>
);
